module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "careers"
  }, [_c('h1', [_vm._v("Join Our Team")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n\t\t\tThank you for your interest in Weboko. There are currently no positions available."), _c('br'), _vm._v("\n\t\t\tPlease visit our site again for future job postings that may relate to your experience and talents.\n\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e535ef2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/careers/careers.vue
// module id = 54
// module chunks = 1